import styled from 'styled-components';
import { ToolTip } from '../..';
import TableCell from '../../table/TableCell';
import Typography from '../../typography/Typography';
export const SwapDetailsContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: 1.6rem;
  padding: 0 1.6rem;

  border-radius: ${({ theme }) => theme.borderRadius.high};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  ${({ theme }) => theme.media.tabletL `
    align-items: start;

    margin-bottom: 2rem;
    padding: 2rem 3.2rem 0;

    border: 0.1rem solid ${theme.colors.borders.default};
  `}
`;
export const DetailsHeader = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;

  margin-bottom: 1.2rem;

  ${({ theme }) => theme.media.tabletL `
    justify-content: space-between;
    flex-direction: row;

    width: 100%;

    margin-bottom: 1.8rem;
    padding: 0;

    background-color:  initial;
  `};
`;
export const IdWrapper = styled.div `
  display: flex;
  align-items: center;

  padding: 0.8rem 1.6rem;
  margin-bottom: 1.2rem;

  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.disabled};

  ${({ theme }) => theme.media.tabletL `
    padding: 0;
    margin-bottom: 0;


    background-color:  initial;
  `};
`;
export const DetailsWrapper = styled.div `
  display: flex;
  flex-direction: column;

  width: 100%;

  padding: 0 1.6rem;

  border-radius: ${({ theme }) => theme.borderRadius.highM};

  background-color: ${({ theme }) => theme.colors.surface.default};

  ${({ theme }) => theme.media.tabletL `
    padding: 2.2rem;
  `};
`;
export const DetailsFieldWrapper = styled.div `
  display: flex;
  align-items: center;

  padding: 1.2rem 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
  }

  ${({ theme }) => theme.media.tabletL `
    &:not(:last-child) {
      margin-bottom: 2.5rem;
      border-bottom: none;
    }
  `};
`;
export const RateInfoWrapper = styled.div `
  display: flex;
  gap: 0.4rem;
  ${({ theme }) => theme.media.tabletL `
    align-items: center;
  `};
`;
export const CustomToolTip = styled(ToolTip) `
  margin-top: 2.4rem;
  ${({ theme }) => theme.media.tabletL `
    margin-top: unset;
  `};
  .tooltip {
    z-index: ${({ theme }) => theme.zIndex.high};
    width: 21.5rem;
    left: -7.5rem;
    white-space: pre-wrap;
    word-break: break-word;
    &:after {
      left: calc(84% - 1.05rem);
    }
  }
`;
export const DetailsTitle = styled(Typography) `
  display: none;

  width: 15%;

  ${({ theme }) => theme.media.tabletL `
    display: initial;
    margin-right: 0.5rem;
  `};
`;
export const ProgressBarWrapper = styled.div `
  display: flex;

  width: 100%;

  padding: 4.2rem 3rem 3.8rem;

  ${({ theme }) => theme.media.tabletL `
    padding: 2.4rem 3.6rem 5.2rem;
  `};
`;
export const IdTitle = styled(Typography) `
  margin-right: 1.6rem;
`;
export const HashTableCell = styled(TableCell) `
  .TableCellDescription {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15rem;
  }
`;
export const AssetTableCell = styled(TableCell) `
  gap: 1rem;
`;
//# sourceMappingURL=styles.js.map